// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-default{position:fixed!important;z-index:999;right:5%;bottom:5%;background:#81c7bd;padding:13px;border-radius:10px;color:#fff;opacity:0;visibility:hidden;transition:.6s ease}.notification-default.copied{transition:.6s ease;opacity:1;visibility:visible}", ""]);
// Exports
module.exports = exports;
